import { atom } from 'recoil';

const lastDeletedActionId = atom<string | null>({
  key: 'lastDeletedFlowActionId',
  default: null,
});

export default lastDeletedActionId;
